import createModule from '../module-helper'

const NAME = 'CCLayoutPackModule'

const MODULE_DIRECTORY = {
    TileToRowsCCPacker: {}
}

const CCLayoutPackModule = createModule(NAME, MODULE_DIRECTORY)
export default CCLayoutPackModule
